import React from "react";
import Receipt from "./Receipt";
import { PDFDownloadLink } from "@react-pdf/renderer";
import LinkDownload from "./LinkDownload";

const PDFBtnReceipt = (props) => {
  const {
    txId,
    email,
    phoneNumber,
    fullName,
    paymentMethod,
    description,
    date,
    price,
  } = props;
  console.log(email);
  return (
    <PDFDownloadLink
      document={
        <Receipt
          txId={txId}
          email={email}
          phoneNumber={phoneNumber}
          fullName={fullName}
          paymentMethod={paymentMethod}
          description={description}
          date={date}
          price={price}
        />
      }
      fileName={`PaymentInvoice-${new Date().toLocaleDateString()}.pdf`}
    >
      {({ loading }) =>
        loading ? (
          <div className="small-container">Loading PDF</div>
        ) : (
          <div className="small-container">
            <LinkDownload />
          </div>
        )
      }
    </PDFDownloadLink>
  );
};

export default PDFBtnReceipt;
